/**
 * Settings: everything Miles may want to change about what the app says or shows, in one place.
 * One file per area (this folder), each a list of UPPER_SNAKE_CASE constants with a one-line note.
 *
 * Rules (docs/rules.md 3b):
 *  - Text typed on a screen belongs here, not in the screen.
 *  - An empty text ("") means hidden: the screen shows nothing there and leaves no gap.
 *  - Words use {name} holes that the screen fills in, e.g. "{count} changes waiting".
 *  - Rules that affect money or permissions stay in packages/core, not here.
 */
export * from "./sync.ts";
export * from "./shared.ts";
export * from "./receipts.ts";

/** Fill the {name} holes in a setting's text. A hole with no value is left empty. */
export function fill(text: string, values: Record<string, string | number> = {}): string {
  return text.replace(/\{(\w+)\}/g, (_, key: string) => String(values[key] ?? ""));
}

/** True when a text setting should show: empty or only spaces means hidden. */
export const shows = (text: string): boolean => text.trim() !== "";
